<template>
    <div v-if="!isLoading" class="pl-lg-4" :key="tick">
        <div class="row">
            <div v-if="isAdmin && typeof profile === 'undefined'" class="col-lg-4">
                <label class="form-control-label">
                    Organisation
                    <span>*</span></label>
                <select v-model="profileDocument.customer"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <!-- <option value="" disabled selected>Kunde</option> -->
                    <option v-for="customer in customers" :key="customer.id" :value="customer['@id']">{{ customer.name }}
                    </option>
                </select>
            </div>
            <div v-if="customerData !== null && !isService && typeof profile === 'undefined'" class="col-lg-4">
                <label class="form-control-label">
                    Benutzer
                    <span>*</span></label>
                <select v-model="profileDocument.user"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option v-for="user in customerData.users" :key="user.id" :value="user['@id']">{{ user.email }}
                    </option>
                </select>
            </div>
            <div v-if="profileDocument.user !== null" class="col-lg-4">
                <label class="form-control-label">
                    Mitarbeiter
                    <span>*</span></label>
                <select v-model="profileDocument.profile"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option v-for="profile in $store.getters['profiles/showProfilesByUserIRI'](profileDocument.user)" :key="profile.id" :value="profile['@id']">{{ profile.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row text-center mt-5" v-if="profileDocument.user !== null && profileDocument.profile !== null && profileDocument.customer !== null && !edit">
            <h3>Wie möchten Sie den Nachweis hochladen?</h3>
        </div>
        <div class="row text-center" v-if="profileDocument.user !== null && profileDocument.profile !== null && profileDocument.customer !== null  && !edit">
                <div class="col card m-3 shadow" @click="mode = 'form'"><font-awesome-icon icon="desktop" size="6x" class="p-3 mx-auto"/><h4>Von diesem PC</h4></div>
                <div class="col card m-3 shadow" @click="displayToken"><font-awesome-icon icon="qrcode" size="6x" class="p-3 mx-auto"/><h4>Von einem Smartphone</h4></div>
        </div>
        <div class="row" v-if="profileDocument.user !== null && profileDocument.profile !== null && profileDocument.customer !== null && mode === 'external'  && !edit">
            <fade-transition>
                <div v-if="qrcode.isLoadingToken" class="col text-center">
                    <h2>Generiere QRCode ...</h2>
                    <font-awesome-icon icon="circle-notch" size="6x" class="p-3 mx-auto" spin/>
                    <h3>Dies kann einen Moment dauern!</h3>
                </div>
                <div v-else class="col text-center">
                    <h3 class="display-4 mt-5 mb-3">Scannen Sie den QR Code mit Ihrem Smartphone</h3>
                    <qr-code class="qrcode" :text="qrcode.link"></qr-code>
                    <h4 class="mt-4">Hinweis</h4>
                    <span class="text-muted">Der QR Code ist nur einmal gültig und hat eine Gültigkeitsdauer von maximal 15 Minuten.</span><br>
                    <span class="text-muted text-underline mt-3 mb-5">Läuft ab {{qrcode.expiresAt|formatDateFromNow}}.</span>
                </div>
            </fade-transition>
        </div>
        <div v-if="mode === 'form' ||  edit" class="row">
            <div class="col mt-5">
                <label class="form-control-label">
                    Dokument
                    <span>*</span></label>
                <upload-field :url="uploadUrl"
                              v-model="profileDocument.document"
                              class="col-form-label col-form-label-lg"
                              v-on:input="downloadFile"
                              input-classes=" form-control-lg input "
                              placeholder="Dokument auswählen oder von PC hochladen" ></upload-field>
            </div>
        </div>
        <fade-transition>
        <div v-if="(mode === 'form' && isTextScanned && !isTextScanning) ||  edit" class="row">
            <div class="col-lg-4">
                <div class="form-group col-form-label col-form-label-lg has-label p-0">
                <label class="form-control-label">
                    Typ
                    <span>*</span></label>
                <select v-model="profileDocument.type"
                        class="custom-select form-control form-control-alternative form-control-lg">
                    <option v-for="d in docOptions" :key="d" :value="d">{{ d }}
                    </option>
                </select>
                </div>
            </div>
            <div class="col-md-8">
                <label class="form-control-label">
                    Bezeichnung
                </label>

                <vue-simple-suggest
                        v-model="profileDocument.name"
                        :list="items"
                        :styles="autoCompleteStyle"
                        display-attribute="name"
                        :filter-by-query="true">
                    <!-- Filter by input text to only show the matching results -->
                </vue-simple-suggest>

            </div>
        </div>
        </fade-transition>
        <fade-transition>
        <div v-if="(mode === 'form' && isTextScanned && !isTextScanning) ||  edit" class="row">
            <div class="col-lg-4">
                <div class="form-group col-form-label col-form-label-lg has-label">
                <label class="form-control-label">
                    Erstschulung?
                </label><br>
                <select v-model="profileDocument.isFirst" claSS="custom-select form-control form-control-alternative form-control-lg">
                    <option :value="true">Erstschulung</option>
                    <option :value="false">Folgeschulung</option>
                </select>
                </div>
            </div>
            <div class="col-lg-4">
                <base-input
                        label="Ausgestellt am:"
                        required
                        class="col-form-label col-form-label-lg"
                >
                    <flat-pickr slot-scope="{focus, blur}"
                                @on-open="focus"
                                @on-close="blur"
                                ref="pickr"
                                :config="config"
                                :class="['form-control','form-control-alternative','form-control-lg','datepicker']"
                                v-model="profileDocument.issuedAt">
                    </flat-pickr>
                </base-input>
            </div>
            <div class="col-lg-4">
                <base-input
                        label="Läuft ab am:"
                        required
                        class="col-form-label col-form-label-lg"
                >
                    <flat-pickr slot-scope="{focus, blur}"
                                @on-open="focus"
                                @on-close="blur"
                                ref="pickr"
                                :config="config"
                                :class="['form-control','form-control-alternative','form-control-lg','datepicker']"
                                v-model="profileDocument.invalidAt">
                    </flat-pickr>
                </base-input>
            </div>
        </div>
        </fade-transition>
        <fade-transition>
        <div v-if="(mode === 'form' && isTextScanned && !isTextScanning) ||  edit" class="row">
            <div class="col">
                <base-input alternative=""
                            required
                            label="Beschreibung"
                            input-classes="form-control-alternative form-control-lg"
                            v-model="profileDocument.description"
                />
            </div>
        </div></fade-transition>
        <fade-transition>
        <div v-if="mode === 'form' && isTextScanning && !edit" class="pl-lg-4 text-center">
            <h2 class="text-muted">Lese Dokument ...</h2>
            <font-awesome-icon icon="circle-notch" size="6x" class="p-3 mx-auto text-muted" spin/>
        </div>
        </fade-transition>
    </div>
    <div v-else class="pl-lg-4 text-center">
        <!---<i class="fas fa-5x fa-circle-notch fa-spin py-5"></i>---->
        <font-awesome-icon icon="circle-notch" size="6x" spin/>
    </div>
</template>
<script>
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import { German } from "flatpickr/dist/l10n/de.js";
    import UploadField from "@/components/UploadField/UploadField";
    import FadeTransition from "vue2-transitions/src/Fade/FadeTransition";
    import axios from 'axios';
    import RecognizeDocumentText from "@/Mixins/RecognizeDocumentText";


    export default {
        name:"profile-document-form",
        components:{FadeTransition, flatPickr, UploadField},
        mixins: [RecognizeDocumentText],
        props:{
            edit:{
                type:Boolean,
                default:false,
                description:"Is edit??"
            },
            profile: {
                type: String,
                default: undefined,
                description: 'Profile ID'
            },
            type:
                {
                    type: String,
                    default: '',
                    description: 'Profile Document Name'
                },
            loadingProp: {
                type: Boolean,
                default: false,
                description: 'is Loading Prop'
            }
        },
        data() {
            return {
                tick: 1,
                docOptions: ['Zertifikat','Schulung','Unterweisung', 'Sonstiges'],
                mode: '',
                docScanned: false,
                qrcode: {
                    token: '',
                    link: '',
                    expiresAt: null,
                    timer: null,
                    isLoadingToken: false
                },
                profileDocument: {
                    profile: null,
                    isFirst: false,
                    document: null,
                    customer: null,
                    user: null,
                    type: '',
                    name: '',
                    description: '',
                    invalidAt: null,
                    issuedAt: null,
                },
                isLoadingData: false,
                isTextScanning: false,
                isTextScanned: false,
                uploadUrl: process.env.VUE_APP_API_SERVER +'/api/documents',
                config: {
                    dateFormat: 'Y-m-d',
                    altFormat: 'd.m.Y',
                    altInput: true,
                    allowInput: true,
                    locale: German
                },
                items: [
                    { id: 1, name: 'Präventionsschulung Servicekraft'},
                    { id: 2, name: 'Schulung Verwaltung'},
                    { id: 3, name: 'Schulung Sozialkonzeptbeauftragte'},
                    { id: 4, name: 'Besondere Schulung (GlüStV $ 29 Abs. 4)'},
                    { id: 5, name: 'Bescheinigung §8 Abs. 2 NSpielhG'},
                    { id: 6, name: 'Dienstanweisung JuSchG'},
                    { id: 7, name: 'Dienstanweisung Sozialkonzept Servicekraft'},
                    { id: 8, name: 'Dienstanweisung Sozialkonzept Verwaltung'},
                    { id: 9, name: 'Dienstanweisung Verpflichtungserklärung'},
                    { id: 10, name: 'Modul A'},
                    { id: 11, name: 'Modul B'},
                    { id: 12, name: 'Sonstige'},
                ],
                autoCompleteStyle : {
                    vueSimpleSuggest: "position-relative",
                    inputWrapper: "input-wrapper",
                    defaultInput : "form-control form-control-alternative form-control-lg",
                    suggestions: "position-absolute list-group z-100-overflow",
                    suggestItem: "list-group-item"
                }
            }
        },
        created(){
            this.isLoadingData = true;
            //todo predefine array ...
            Promise.all([this.$store.dispatch('profiles/getProfiles'),this.$store.dispatch('customer/getCustomerCollection')]).then(() => {
                this.init();
                this.isLoadingData = false;
            });

            /*
            if (!this.$store.getters['profiles/isReady']) {
                this.$store.dispatch('profiles/getProfiles'); }
            if (!this.$store.getters['customer/isReady']) {
                this.$store.dispatch('customer/getCustomerCollection').then(() => {
                    this.init();
                });
            } else {
                this.init();
            }*/
        },
        computed: {
            customers() {
                return this.$store.getters['customer/showCustomerCollection'];
            },
            customerData() {
                return (this.$store.getters['customer/isReady'] && this.profileDocument.customer !== null) ? this.$store.getters['customer/showCustomerByIRI'](this.profileDocument.customer) : {customer:{id:0,name: 'placeholder'}};
            },
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            isService() {
                return this.$store.getters['authentication/isService'];
            },
            availableOptions() {
                return this.options.filter(opt => this.profileDocument.type.indexOf(opt) === -1)
            },
            isLoading() {
                return this.isLoadingData || this.loadingProp;
            }
        },
        methods: {
            init() {
                if (!this.edit) {
                    if (typeof this.profile === "undefined") {
                        if (this.$store.getters['customer/showCustomerCollection'].length === 1) {
                            this.profileDocument.customer = this.$store.getters['customer/showCustomerCollection'][0]['@id'];
                        } else {
                            this.profileDocument.customer = '/api/customers/'+this.$store.getters['authentication/customer'];
                        }
                        if (this.$store.getters['authentication/isService']) {
                            this.profileDocument.user = '/api/users/' + this.$store.getters['authentication/uid'];
                        }
                    } else {
                        this.profileDocument.profile = '/api/profiles/'+this.profile;
                        let usr = this.$store.getters['profiles/showProfileByIRI'](this.profileDocument.profile).user;
                        this.profileDocument.user = usr['@id'];
                        this.profileDocument.customer = usr.customer['@id'];
                    }

                    this.profileDocument.name = this.type;
                }
            },
            isValid(token) {
                return new Promise((resolve, reject) => {
                    const requestOptions = {
                        method: 'GET',
                        // headers: { 'Content-Type': 'application/json' },
                    };

                    fetch(process.env.VUE_APP_API_SERVER + `/pd/validtoken/` + token, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                            },
                            error => {
                                reject(error);

                            });
                });
            },
            displayToken(){
                this.mode = 'external'
                this.qrcode.isLoadingToken = true;
                this.getToken().then(response => {
                    this.qrcode.link = response.link;
                    this.qrcode.expiresAt = response.expiresAt;
                    this.qrcode.token = response.token;
                    this.qrcode.isLoadingToken = false;
                    this.qrcode.timer =  setInterval(() => {
                        this.isValid(this.qrcode.token).then(response => {
                            if (!response.status) {
                                this.$router.push('/users/profiles_documents');
                                clearInterval(this.qrcode.timer);
                            }
                        })
                    }, 3000);

                }).catch(error => {
                    this.$store.dispatch('alert/error',error);
                    this.qrcode.isLoadingToken = false;
                })
            },
            getToken() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = {
                        user: this.profileDocument.user,
                        customer: this.profileDocument.customer,
                        profile: this.profileDocument.profile,
                        logintoken: JSON.parse(localStorage.getItem('token'))
                    };
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/pd_tokens`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response)
                            },
                            error => {
                                reject(error);
                            });
                });

            },
            downloadFile(id) {
                this.isTextScanning = true;
                this.profileDocument.issuedAt = null;
                this.profileDocument.expiresAt = null;
                this.profileDocument.name = null;
                this.profileDocument.type = null;
                this.profileDocument.description = null;
                id = id.split('s/')[1];
                let head = this.authHeader();
                head['Accept'] = 'application/octet-stream';
                axios({
                    url: process.env.VUE_APP_API_SERVER + '/document/show/' + id,
                    headers: head,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    // image url for further processing
                    let url,type;
                    url = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}));
                    type = response.data.type;
                    if (type === 'application/pdf') {
                        this.convertBlobToImage(response.data).then(img => {
                            this.recognizeDocument(img.data).then(resp => {
                                this.fillForm(resp)
                                this.stopLoading()
                            }).catch(err => {
                                this.$store.dispatch('alert/error','Da ist etwas schief gelaufen. Das Dokument konnte nicht gelesen werden. FEHLER: '+ err)
                                this.stopLoading()
                            })
                        }).catch(err => {
                            this.$store.dispatch('alert/error','Da ist etwas schief gelaufen. FEHLER: '+err)
                            this.stopLoading()
                        })
                    } else {
                        // eslint-disable-next-line no-console
                        console.log(url)
                        // tesseract ocr =>  prefill form
                        this.recognizeDocument(url).then(resp => {
                            this.fillForm(resp)
                            this.stopLoading()
                        }).catch(err => {
                            this.$store.dispatch('alert/error','Da ist etwas schief gelaufen. Das Dokument konnte nicht gelesen werden. FEHLER: '+ err)
                            this.stopLoading()
                        })
                    }
                }, (error) => {
                    this.$store.dispatch('alert/error',error);
                    this.stopLoading()
                });
            },
            fillForm(resp) {
                this.profileDocument.issuedAt = resp.issuedAt;
                this.profileDocument.expiresAt = resp.expiresAt;
                this.profileDocument.name = resp.name;
                this.profileDocument.type = resp.type;
                this.profileDocument.description = resp.description;
            },
            stopLoading() {
                this.isTextScanned = true;
                this.isTextScanning = false;
                this.tick++
            }

        }
    }
</script>

<style scoped>
    .card:hover {
        background-color: #5e72e4;
    }

    .qrcode {
        width: 256px;
        margin-left: auto;
        margin-right: auto;
        /* Styles for the parent node */
    }
    .qrcode > img {
        display: none !important;
        margin-left: auto;
        margin-right: auto;
        /* Styles for the image */
    }

</style>